import React from 'react';

import classes from './Loader.module.css';

import { Modal, Spinner } from 'react-bootstrap';

const Loader = (props: any) => {

  return (
    <Modal
      dialogClassName={classes.loader}
      show={props.show}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body>
        <Spinner animation="border" variant="primary" />
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(
  Loader,
  (prevProps, nextProps) =>
    nextProps.show === prevProps.show
);
